var React = require("react");
var useState = React.useState;
var useEffect = React.useEffect;

var API_BASE = "https://surabaya-api.onrender.com";

function MenuSelection(props) {
  var nbPersonnes = props.nbPersonnes || 2;
  var onValidate = props.onValidate;
  var onSkip = props.onSkip;
  var _menu = useState(null); var menu = _menu[0]; var setMenu = _menu[1];
  var _loading = useState(true); var loading = _loading[0]; var setLoading = _loading[1];
  var _error = useState(null); var error = _error[0]; var setError = _error[1];
  var _sel = useState({}); var sel = _sel[0]; var setSel = _sel[1];

  useEffect(function() {
    fetch(API_BASE + "/api/menu")
      .then(function(r) { return r.json(); })
      .then(function(data) { setMenu(data); setLoading(false); })
      .catch(function(err) { setError(err.message); setLoading(false); });
  }, []);

  function updateQty(itemId, delta) {
    setSel(function(prev) {
      var current = prev[itemId] || 0;
      var newQty = Math.max(0, current + delta);
      var copy = Object.assign({}, prev);
      if (newQty === 0) { delete copy[itemId]; } else { copy[itemId] = newQty; }
      return copy;
    });
  }

  function findItem(id) {
    if (!menu) return null;
    for (var i = 0; i < menu.categories.length; i++) {
      for (var j = 0; j < menu.categories[i].items.length; j++) {
        if (menu.categories[i].items[j].id === id) return menu.categories[i].items[j];
      }
    }
    return null;
  }

  function getTotal() {
    var total = 0; var count = 0;
    var keys = Object.keys(sel);
    for (var i = 0; i < keys.length; i++) {
      var item = findItem(parseInt(keys[i]));
      if (item) { total += item.price * sel[keys[i]]; count += sel[keys[i]]; }
    }
    return { total: total, count: count };
  }

  function handleValidate() {
    var items = [];
    var keys = Object.keys(sel);
    for (var i = 0; i < keys.length; i++) {
      var item = findItem(parseInt(keys[i]));
      if (item && sel[keys[i]] > 0) {
        items.push({ productId: item.id, name: item.name, price: item.price, quantity: sel[keys[i]], category: item.category });
      }
    }
    var t = getTotal();
    onValidate({ items: items, total: t.total, totalItems: t.count });
  }

  var gold = "#e8c47c";
  var darkBg = "rgba(232,196,124,0.08)";
  var borderGold = "1px solid rgba(232,196,124,0.2)";

  if (loading) {
    return React.createElement("div", {style:{textAlign:"center",padding:"40px 20px",color:"#999"}},
      React.createElement("div", {style:{fontSize:40,marginBottom:12}}, "\uD83C\uDF7D\uFE0F"),
      React.createElement("p", null, "Chargement de la carte..."));
  }

  if (error || !menu) {
    return React.createElement("div", {style:{textAlign:"center",padding:"40px 20px",color:"#999"}},
      React.createElement("p", null, "La carte n\u2019est pas disponible pour le moment."),
      onSkip && React.createElement("button", {onClick:onSkip,style:{padding:"10px 24px",borderRadius:10,border:borderGold,background:"transparent",color:gold,cursor:"pointer",marginTop:12,fontSize:14}}, "Continuer sans choisir"));
  }

  var t = getTotal();

  return React.createElement("div", {style:{maxWidth:600,margin:"0 auto"}},
    React.createElement("div", {style:{textAlign:"center",marginBottom:20}},
      React.createElement("h2", {style:{color:gold,fontSize:20,margin:"0 0 6px"}}, "\uD83C\uDF7D\uFE0F Notre Carte"),
      React.createElement("p", {style:{color:"#999",fontSize:13,fontStyle:"italic"}}, "Pre-commandez pour " + nbPersonnes + " personne" + (nbPersonnes > 1 ? "s" : "") + " ou choisissez sur place !")),

    menu.categories.map(function(cat) {
      return React.createElement("div", {key:cat.id,style:{marginBottom:20}},
        React.createElement("h3", {style:{color:gold,fontSize:16,borderBottom:"1px solid rgba(232,196,124,0.3)",paddingBottom:6,marginBottom:10}}, cat.name),
        cat.items.map(function(item) {
          var qty = sel[item.id] || 0;
          var isUnavail = !item.available;
          var isLow = item.stockManaged && item.stock !== null && item.stock > 0 && item.stock <= 3;
          return React.createElement("div", {key:item.id,style:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",marginBottom:6,borderRadius:10,background:qty > 0 ? "rgba(232,196,124,0.15)" : darkBg,border:qty > 0 ? "2px solid rgba(232,196,124,0.4)" : borderGold,opacity:isUnavail?0.5:1}},
            React.createElement("div", {style:{flex:1}},
              React.createElement("div", {style:{color:"white",fontSize:14,fontWeight:600,textDecoration:isUnavail?"line-through":"none"}}, item.name),
              item.description && React.createElement("div", {style:{color:"#999",fontSize:12}}, item.description),
              isLow && React.createElement("div", {style:{color:"#f59e0b",fontSize:11}}, "\u26A1 Plus que " + item.stock + " dispo" + (item.stock > 1 ? "s" : "") + " !")),
            React.createElement("div", {style:{color:gold,fontWeight:"bold",fontSize:14,marginLeft:12,whiteSpace:"nowrap"}}, item.price.toFixed(2) + " \u20AC"),
            isUnavail
              ? React.createElement("div", {style:{color:"#ef4444",fontSize:11,fontWeight:"bold",marginLeft:10,whiteSpace:"nowrap"}}, "Victime de son succes !")
              : React.createElement("div", {style:{display:"flex",alignItems:"center",gap:8,marginLeft:12}},
                  qty > 0 && React.createElement("button", {onClick:function(){updateQty(item.id,-1)},style:{width:28,height:28,borderRadius:"50%",border:"2px solid "+gold,background:"transparent",color:gold,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}, "\u2212"),
                  qty > 0 && React.createElement("span", {style:{color:"white",fontWeight:"bold",minWidth:20,textAlign:"center"}}, qty),
                  React.createElement("button", {onClick:function(){updateQty(item.id,1)},style:{width:28,height:28,borderRadius:"50%",border:"2px solid "+gold,background:qty>0?gold:"transparent",color:qty>0?"#2d1a0e":gold,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}, "+"))
          );
        })
      );
    }),

    React.createElement("div", {style:{background:"rgba(59,130,246,0.1)",border:"1px solid rgba(59,130,246,0.2)",borderRadius:10,padding:"10px 14px",margin:"16px 0",fontSize:12,color:"#93c5fd"}},
      "\uD83D\uDCA1 Envie d\u2019un plat affiche complet ? Tentez votre chance sur place ou appelez-nous ! \uD83D\uDCDE 07 68 35 97 87"),

    React.createElement("div", {style:{background:"rgba(232,196,124,0.1)",borderRadius:12,padding:16,textAlign:"center",marginTop:16}},
      t.count > 0 && React.createElement("div", null,
        React.createElement("div", {style:{color:"#999",fontSize:13,marginBottom:4}}, t.count + " plat" + (t.count > 1 ? "s" : "") + " selectionne" + (t.count > 1 ? "s" : "")),
        React.createElement("div", {style:{color:gold,fontSize:20,fontWeight:"bold",marginBottom:12}}, "Total estime : " + t.total.toFixed(2) + " \u20AC")),
      t.count > 0 && React.createElement("button", {onClick:handleValidate,style:{padding:"12px 28px",borderRadius:10,border:"none",background:"linear-gradient(135deg,#8B6914,#e8c47c)",color:"#2d1a0e",fontSize:14,fontWeight:700,cursor:"pointer",marginRight:10}}, "\u2705 Valider ma pre-commande"),
      React.createElement("button", {onClick:onSkip,style:{padding:"12px 28px",borderRadius:10,border:borderGold,background:"transparent",color:gold,fontSize:13,cursor:"pointer"}}, "Je choisirai sur place"))
  );
}

module.exports = MenuSelection;

